import { useState, useCallback } from 'react';

const DEFAULT_TAB = '1';

const readTabFromStorage = (storageKey: string): string => {
  const key = `${storageKey}-active-tab`;
  const stored = sessionStorage.getItem(key);

  if (!stored) {
    return DEFAULT_TAB;
  }

  return stored;
};

export const useActiveTab = (storageKey: string) => {
  const initialTab = readTabFromStorage(storageKey);

  const [activeTab, setActiveTab] = useState<string>(initialTab);

  const setActiveTabWithStorage = useCallback(
    (tabKey: string) => {
      sessionStorage.setItem(`${storageKey}-active-tab`, tabKey);
      setActiveTab(tabKey);
    },
    [storageKey]
  );

  return {
    activeTab,
    setActiveTab: setActiveTabWithStorage
  };
};

export default useActiveTab;
